import { useState } from "react";

import { EmptyState, Icon } from "@/components/common";
import { useAuth } from "@/auth/useAuth";
import { useActiveWorkspace } from "@/contexts/WorkspaceContext";
import { getInitials } from "@/utils/initials";
import "./WorkspaceSwitcher.css";

export function WorkspaceSwitcher() {
  const { user } = useAuth();
  const { activeWorkspaceId, setActiveWorkspaceId } = useActiveWorkspace();
  const [open, setOpen] = useState(false);

  const workspaces = user?.manageableWorkspaces ?? [];
  const active = workspaces.find((w) => w.id === activeWorkspaceId) ?? workspaces[0];

  async function pick(id: number) {
    setOpen(false);
    await setActiveWorkspaceId(id);
  }

  return (
    <>
      <button className="workspace-switcher" onClick={() => setOpen(true)}>
        <span className="ws-mark">{getInitials(active?.name)}</span>
        <span className="ws-info">
          <span className="ws-label">Workspace</span>
          <span className="ws-name">{active?.name ?? "—"}</span>
        </span>
        <Icon name="chevrons-up-down" size={16} className="ws-chev" />
      </button>

      {open && (
        <div className="popover-backdrop" onClick={() => setOpen(false)}>
          <div className="popover wsx-pop" onClick={(e) => e.stopPropagation()}>
            <div className="ws-section-label">Meus workspaces</div>
            <div className="ws-list">
              {workspaces.length === 0 && (
                <EmptyState
                  size="sm"
                  icon="building"
                  title="Nenhum workspace disponível"
                  description="Você ainda não tem acesso a nenhum workspace. Peça um convite ao administrador."
                />
              )}
              {workspaces.map((w) => (
                <button
                  key={w.id}
                  className={`ws-row ${w.id === activeWorkspaceId ? "current" : ""}`}
                  onClick={() => void pick(w.id)}
                >
                  <span
                    className="ws-row-mark"
                    style={{ background: "linear-gradient(135deg,#FFD96B,#F4CC04)" }}
                  >
                    {getInitials(w.name)}
                  </span>
                  <span className="ws-row-info">
                    <span className="ws-row-name">{w.name}</span>
                    <span className="ws-row-meta">
                      {w.is_platform_tenant ? "Plataforma TDAX" : w.slug}
                    </span>
                  </span>
                  {w.id === activeWorkspaceId && (
                    <span className="ws-row-check">
                      <Icon name="check" size={13} stroke={3} />
                    </span>
                  )}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
